module.exports = __webpack_public_path__ + "static/media/sinpas-finans-sehir-3-bed.bcaf97ac.jpg";